import React from "react";
import { CalendarIcon } from "@fluentui/react-icons-northstar";
import { ReportFilterBase } from "./abstractions/ReportFilterBase";
import { Year } from "../models";

export interface YearsFilterProps {
    years: Year[];
    multiple?: boolean;
    atLeastOneAlwaysSelected?: boolean;
    onSelectedYearsChanged: (years: Year[]) => void;
    isMobileView: boolean;
}

export const YearsFilter: React.FC<YearsFilterProps> = ({
    years,
    multiple,
    atLeastOneAlwaysSelected,
    onSelectedYearsChanged,
    isMobileView,
}) => {
    return (
        <ReportFilterBase
            icon={<CalendarIcon outline />}
            prefix="Rok"
            items={years}
            multiple={multiple}
            atLeastOneAlwaysSelected={atLeastOneAlwaysSelected}
            onSelectedItemsChanged={(years) => onSelectedYearsChanged(years as Year[])}
            isMobileView={isMobileView}
        />
    );
};
